import { __ } from "@wordpress/i18n";
import { useSelect } from "@wordpress/data";

import Person from "./components/Person";
export const BoardMember = ({
  attributes,
  sortedMembers,
  formData,
  setAttributes,
}) => {

  const {
    displayFeaturedImage,
    displayName,
    displayTitle,
    displayDesignation,
    displayPhone,
    categories,
    displayEmail,
    displayCity,
    displayProfileLink,
    displaySocialLink,
    displayHomeLink,
    displayRankNumber,
    displayVaralla,
    selectedValue,
    memberTitle,
    memberDesc,
  } = attributes;
  const onChangeMemberTitle = (value) => {
    setAttributes({ memberTitle: value });
  };
  const onChangeMemeberDesc = (value) => {
    setAttributes({ memberDesc: value });
  };
  const categoryID =
    categories && categories.length > 0 ? categories && categories[0].id : null;
  const taxonomy = useSelect((select) => {
    return select("core").getEntityRecords("taxonomy", "group", {
      include: [categoryID],
    });
  });
  const rank_info_db = taxonomy && taxonomy[0] && taxonomy[0].rank_information;

  const flatArray = formData.flatMap((item) => {
    if (typeof item === "object" && !Array.isArray(item)) {
      return Object.values(item);
    } else {
      return item;
    }
  });

  // console.log(flatArray);

  const numberOfColumns = 4;

  const rank_info_form_data = {};

  for (let i = 0; i < flatArray.length; i += numberOfColumns) {
    const subArray = flatArray.slice(i, i + numberOfColumns);
    rank_info_form_data[i / numberOfColumns] = subArray;
  }

  let rank_infos = {};
  if (
    rank_info_db &&
    rank_info_db !== "a:0:{}" &&
    rank_info_db !== "a:1:{i:0;a:0:{}}"
  ) {
    function unserialize(data) {
      return data.match(/s:([0-9]+):"(.*?)";/g).map(function (s) {
        var m = s.match(/s:([0-9]+):"(.*?)";/);
        if (m) {
          if (m[2].startsWith("a:") || m[2].startsWith("O:")) {
            return JSON.parse(deserializeValue(m[2]));
          } else {
            return m[2];
          }
        } else {
          return s;
        }
      });
    }

    function deserializeValue(value) {
      var deserialized = unserialize(value);
      return deserialized.length === 1 ? deserialized[0] : deserialized;
    }

    const deserializedMetadata = unserialize(rank_info_db);

    // Convert the flat array to a JSON object
    for (let i = 0; i < deserializedMetadata.length; i += 4) {
      rank_infos[i / 4] = deserializedMetadata.slice(i, i + 4);
    }
  } else {
    // console.warn("Taxonomy or rank_information is null.");
  }
  let rank_info = {};
  function empty(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  if (!empty(rank_info_form_data)) {
    rank_info = rank_info_form_data;
  } else {
    rank_info = rank_infos;
  }

  const specificParentId = categories?.[0]?.id;
  const catIds = sortedMembers.map((person) => person.group).flat();
  const categoriesInfo = useSelect((select) => {
    const allCategories = select("core").getEntityRecords("taxonomy", "group", {
      include: catIds,
    });

    return allCategories?.map((category) => ({
      id: category.id,
      name: category.name,
      character: category.parent ? "child" : "parent",
      parentId: category.parent || null,
    })) || [];
  }, [catIds]);

  const childCats = categoriesInfo.filter((category) => category.parentId === specificParentId);

  const parentMembers = sortedMembers.filter((person) => {
    const isParent = person.group.includes(specificParentId); // Belongs to parent category
    const hasNoChildren = !childCats.some((childCat) => person.group.includes(childCat.id)); // Does not belong to any child category
    return isParent && hasNoChildren;
  });

  const childMembersByCategory = {};

  // Loop through child categories and create dynamic variables
  childCats.forEach((childCat, index) => {
    childMembersByCategory[`childMembers${index + 1}`] = sortedMembers.filter((person) =>
      person.group.includes(childCat.id)
    );
  });

  return (
    <>
      {categories && categories.length > 0 ? (
        <>
          <h3 className="people-block-title">
            {categories && categories[0]
              ? categories[0].name
              : __("Group Name", "artcloud-manage-people")}
          </h3>
          {
            childCats && childCats[0] && childCats[0].description ? (
              <p className="people-block-desc">
                {childCats[0].description}
              </p>
            ) : null
          }

          <div className="artcloud-row row-1">
            {parentMembers &&
              parentMembers.map((person) =>
                <Person rank_info={rank_info} person={person} key={person.id} selectedValue={selectedValue} displayName={displayName} displayFeaturedImage={displayFeaturedImage} displayVaralla={displayVaralla} displayCity={displayCity} displayDesignation={displayDesignation} displayEmail={displayEmail} displayHomeLink={displayHomeLink} displayPhone={displayPhone} displayProfileLink={displayProfileLink} displayRankNumber={displayRankNumber} displaySocialLink={displaySocialLink} displayTitle={displayTitle} />
              )}
          </div>
          <>
            {Object.keys(childMembersByCategory).map((key, index) => (
              <>
                <hr />
                <h3 className="people-block-title">
                  {childCats && childCats[index]
                    ? childCats[index].name
                    : __("Sub-Group Name", "artcloud-manage-people")}
                </h3>
                {
                  childCats && childCats[index] && childCats[index].description ? (
                    <p className="people-block-desc">
                      {childCats[index].description}
                    </p>
                  ) : null
                }

                <div key={index} className="artcloud-row row-1">
                  {childMembersByCategory[key].map((person) => (
                    <Person rank_info={rank_info} person={person} key={person.id} selectedValue={selectedValue} displayName={displayName} displayFeaturedImage={displayFeaturedImage} displayVaralla={displayVaralla} displayCity={displayCity} displayDesignation={displayDesignation} displayEmail={displayEmail} displayHomeLink={displayHomeLink} displayPhone={displayPhone} displayProfileLink={displayProfileLink} displayRankNumber={displayRankNumber} displaySocialLink={displaySocialLink} displayTitle={displayTitle} />
                  ))}
                </div>
              </>
            ))}
          </>
        </>
      ) : (
        <p>
          {__("Select a category first", "artcloud-manage-people")}
          <hr />
        </p>
      )
      }
    </>
  );
};
